import { apiRequest } from './apiClient';

export async function fetchMailIds() {
  const result = await apiRequest('/settings/mail-ids');
  return result.data;
}

export async function createMailId(payload) {
  const result = await apiRequest('/settings/mail-ids', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  return result;
}

export async function saveDefaultMailIds(defaultMailIds) {
  return apiRequest('/settings/mail-ids', {
    method: 'PUT',
    // `mailIds` keeps this compatible with older deployed backends while
    // `defaultMailIds` is used by the current structured settings API.
    body: JSON.stringify({ defaultMailIds, mailIds: defaultMailIds }),
  });
}

export async function deleteMailId(id) {
  return apiRequest(`/settings/mail-ids/${id}`, { method: 'DELETE' });
}

export async function updateMailId(id, payload) {
  return apiRequest(`/settings/mail-ids/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}
